import { useEffect } from 'react';
import Router from 'next/router';
import { BackHistoryStorage } from '../utils/helpers/BackHistoryStorage';

let hasCheckedReferrerThisLoad = false;

export const resetReferrerCheckForTests = (): void => {
  hasCheckedReferrerThisLoad = false;
};

const getFullPath = (location: {
  pathname: string;
  search: string;
  hash: string;
}) => `${location.pathname}${location.search}${location.hash}`;

let beforeRouteChange = {
  historyStateKey: undefined as string | undefined,
  fullPath: ''
};

let hasRegisteredRouteChangeListeners = false;

const registerRouteChangeListeners = () => {
  if (hasRegisteredRouteChangeListeners || typeof window === 'undefined') {
    return;
  }
  hasRegisteredRouteChangeListeners = true;

  Router.events.on('routeChangeStart', () => {
    beforeRouteChange = {
      historyStateKey: window.history.state?.key,
      fullPath: getFullPath(window.location)
    };
  });

  Router.events.on('routeChangeComplete', () => {
    const isPush =
      window.history.state?.key !== beforeRouteChange.historyStateKey;
    if (!isPush) return;

    BackHistoryStorage.setBackHistoryStorage();

    const initialPath = BackHistoryStorage.getBackHistoryStorageInitialPath();
    if (!initialPath) {
      BackHistoryStorage.setBackHistoryStorageInitialPath(
        beforeRouteChange.fullPath
      );
    }
  });
};

export const useBackHistoryStorage = (): void => {
  registerRouteChangeListeners();

  useEffect(() => {
    if (hasCheckedReferrerThisLoad) return;
    hasCheckedReferrerThisLoad = true;

    if (BackHistoryStorage.consumeHistoryBoundaryReload()) {
      BackHistoryStorage.removeBackHistoryStorage();
      return;
    }

    const { referrer } = document;
    const referrerUrl = referrer ? new URL(referrer) : null;
    const isSameOriginReferrer =
      !!referrerUrl && referrerUrl.origin === window.location.origin;
    const hasRealTabHistory = window.history.length > 1;

    if (isSameOriginReferrer && hasRealTabHistory) {
      BackHistoryStorage.setBackHistoryStorage();

      const initialPath = BackHistoryStorage.getBackHistoryStorageInitialPath();
      if (!initialPath) {
        BackHistoryStorage.setBackHistoryStorageInitialPath(
          getFullPath(referrerUrl)
        );
      }
    } else {
      BackHistoryStorage.removeBackHistoryStorage();
    }
  }, []);

  useEffect(() => {
    const handleHistoryBackEvent = () => {
      const initialPath = BackHistoryStorage.getBackHistoryStorageInitialPath();

      if (initialPath === getFullPath(window.location)) {
        BackHistoryStorage.removeBackHistoryStorage();
      }
    };

    window.addEventListener('popstate', handleHistoryBackEvent);

    return () => {
      window.removeEventListener('popstate', handleHistoryBackEvent);
    };
  }, []);
};
